// extracted by mini-css-extract-plugin
export default {"infoBox":"SelectOutputs_infoBox__Hod4X","nextButton":"SelectOutputs_nextButton__OvLc+","backButton":"SelectOutputs_backButton__QX+En","SaveButton":"SelectOutputs_SaveButton__JW8Sz"};